import { lazy } from "react";

export const PageViewAbout = lazy(() => import("./About"));
export const PageViewMissionVision = lazy(() => import("./MissionVision"));
